import React from "react";
import "./Button.css";

const Style = ["btn--solid", "btn--outline", "btn--icon-outline"];
const Size = ["btn--icon-size-promo", "btn--size", "btn--min"];

export default function ButtonPromo({
  children,
  type,
  onClick,
  buttonStyle,
  buttonSize,
  disabled
}) {
  const checkButtonStyle = Style.includes(buttonStyle) ? buttonStyle : Style[0];
  const checkButtonSize = Size.includes(buttonSize) ? buttonSize : Size[0];

  return (
    <button
      className={`btn Syne700 ${checkButtonStyle} ${checkButtonSize}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
